import { useDispatch, useSelector } from "react-redux";
import { deleteBuilding } from "../services/buildingDeleteService";
import { fetchBuildings } from "../../../../../redux/buildings/buildingsSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/buildings/buildingsPaginationSlice";
import {
  clearSelectedBuilding,
  selectedBuilding,
} from "../../../../../redux/buildings/selectedBuildingSlice";

const useBuildingDelete = () => {
  const dispatch = useDispatch();
  const localSelectedBuilding = useSelector(selectedBuilding);
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const deleteSelectedBuilding = async () => {
    if (!localSelectedBuilding) {
      throw new Error("Please select a Building to delete.");
    }
    try {
      await deleteBuilding(localSelectedBuilding.buildingID);
      dispatch(clearSelectedBuilding());
      // Re-fetch buildings using current pagination values
      dispatch(fetchBuildings({ currentPage, rowsPerPage, searchQuery: "" }));
      return true;
    } catch (error) {
      throw error;
    }
  };

  return deleteSelectedBuilding;
};

export default useBuildingDelete;
